export default "__VITE_ASSET__BvbWR1IX__"